import React from 'react';
import { useBatchProgress } from '../context/BatchProgressContext';
import { useLocale } from '../context/DynamicLocaleProvider';
import { useTheme } from '../context/ThemeProvider';
import BatchSpinnerIcon from './BatchSpinnerIcon';
import styles from './BatchProgressIndicator.module.css';

const SPINNER_COLOR_LIGHT = 'var(--amethyst-smoke)';
const SPINNER_COLOR_DARK = 'var(--amethyst-smoke)';

export default function BatchProgressIndicator() {
  const { batchState } = useBatchProgress();
  const { t } = useLocale();
  const { theme } = useTheme();

  if (!batchState?.active || batchState.total === 0) {
    return null;
  }

  const label = (t('batch_progress_label') || 'Processing {count} documents')
    .replace('{count}', String(batchState.total));

  const spinnerColor = theme === 'dark' ? SPINNER_COLOR_DARK : SPINNER_COLOR_LIGHT;

  return (
    <div className={styles.container} role="status" aria-live="polite">
      <div className={styles.content}>
        <span className={styles.spinnerWrapper}>
          <BatchSpinnerIcon color={spinnerColor} size={24} />
        </span>
        <div className={styles.text}>
          <span className={styles.label}>{label}</span>
          <span className={styles.hint}>{t('batch_progress_hint') || 'You can keep working—processing runs in background'}</span>
        </div>
      </div>
    </div>
  );
}
